import { useEffect, useState } from 'react';
import { isAuthenticated } from '@/api/auth';
import { AUTH_SESSION_EXPIRED_EVENT } from '@/api/authSession';
/** Реактивное «залогинен ли пользователь» (localStorage + exp + 401). */
export function useAuthSession() {
    const [authenticated, setAuthenticated] = useState(() => isAuthenticated());
    useEffect(() => {
        const sync = () => setAuthenticated(isAuthenticated());
        window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, sync);
        return () => window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, sync);
    }, []);
    return authenticated;
}
